<template>
  <v-card flat class="dialog-card">
    <v-toolbar flat light color="white">
      <v-toolbar-title>{{ $t('payments') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <payment-rows :payments="debt.payments"></payment-rows>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import Payments from '../Tabs/Payments.vue'

  export default {
    props: ['debt'],
    components: {
      'payment-rows': Payments
    }
  }
</script>
